class CheckoutOfferBar extends HTMLElement {
    constructor() {
        super();
        this.cartCountObserver = null;
        this.checkoutOfferBar = this;
        this.offTenMessage = this.querySelector(".offer-text-below .off-10")
        this.offFiveMessage = this.querySelector(".offer-text-below .off-5")
        this.offBuy3Message = this.querySelector(".offer-text-below .off-buy-3")

        this.dotFirst = this.querySelector('.dot.first')
        this.dotSecond = this.querySelector('.dot.second')
        this.dotThird = this.querySelector('.dot.third')

        this.freebieVariants = {
            s: 41093967642679,
            m: 41093967675447,
            l: 41093967708215,
            xl: 41093967740983
        }
        this.isFreebieAdded = false;
        this.addedVariantId = null;

        this.updateFreebie = this.updateFreebie.bind(this);

        this.excludedProducts = [7345783767095, 7345783701559]
        this.excludedProductInCart = false;
        this.checkingExcludedProduct = true;
    }

    connectedCallback() {
        this.checkExcludedProductInCart()

        this.progressMeter = this.querySelector('[data-free-shipping-progress-meter]');
        this.cartCountElement = document.querySelector('.cart-count');
        this.cartCount = parseInt(this.cartCountElement?.innerText) || 0;

        this.cartPrice = this.dataset.cartPrice
        if (this.cartPrice) {
            this.cartPrice = parseInt(this.cartPrice)
        }

        this.isFreebieAdded = localStorage.getItem('isFreebieAdded') === 'true';
        this.addedVariantId = localStorage.getItem('addedVariantId') ? parseInt(localStorage.getItem('addedVariantId')) : null;

        document.addEventListener("cartOfferUpdate", (e) => {
            this.checkExcludedProductInCart()
            this.cartCount = e.detail.newCount;
            this.cartPrice = e.detail.newPrice;
            this.progressInit();
            this.handleMessage();
            document.getElementById("freebie_size")?.addEventListener("change", this.updateFreebie);
        });

        // document.getElementById("freebie_size")?.addEventListener("change", this.updateFreebie);

        this.progressInit();
        this.handleMessage();
    }

    disconnectedCallback() {

        if (this.cartCountObserver) {
            this.cartCountObserver.disconnect();
        }
        document.removeEventListener("cartOfferUpdate", this.handleCartCountUpdate);
        // document.getElementById("freebie_size")?.removeEventListener("change", this.updateFreebie);
    }

    // watchForFreebieSize() {
    //     const target = document.getElementById('freebie_size');
    //     if (target) {
    //         target.addEventListener('change', this.updateFreebie);
    //         // Optionally, remove the observer once the target is found to avoid duplicates
    //         observer.disconnect();
    //     }
    // };

    // observer = new MutationObserver((mutations) => {
    //     // Watch for changes in the subtree where #freebie_size might appear
    //     this.watchForFreebieSize();
    // });

    // initMutationObserver() {
    //     this.observer.observe(document.body, {
    //         childList: true,
    //         subtree: true,
    //     });
    // }

    progressInit() {
        if (!this.cartCount || this.cartCount == 0 || this.excludedProductInCart) {
            this.style.display = "none"
        } else if (!this.checkExcludedProductInCart) {
            this.style.display = "block"
        }
        if (!this.progressMeter) return;
        this.progressMeter.style.width = '33%';

        if (this.cartCount >= 3) {
            this.progressMeter.style.width = '100%';
        } else if (this.cartCount >= 2) {
            this.progressMeter.style.width = '54%';
        } else {
            this.progressMeter.style.width = '25%';
        }
    }

    handleMessage() {
        if (!this.offTenMessage || !this.offFiveMessage || this.excludedProductInCart) return;

        // Reset messages & dots
        this.offFiveMessage.style.display = "none";
        this.offTenMessage.style.display = "none";
        this.offBuy3Message.style.display = "none";

        this.dotFirst.style.display = "none";
        this.dotSecond.style.display = "none";
        this.dotThird.style.display = "none";

        if (this.cartCount >= 3) {
            // High value: All milestones met for 10% off
            this.offBuy3Message.textContent = "Extra 10% Off Applied!";
            this.offBuy3Message.style.display = "block";

            this.dotFirst.style.display = "block";
            this.dotSecond.style.display = "block";
            this.dotThird.style.display = "block";

        } else if (this.cartCount >= 2) {
            // Have 5% off. Next goal: 10% off (3 items)
            this.offBuy3Message.innerHTML = "Buy 3 or More Products and Get an <b>Extra 10% Off</b>";
            this.offBuy3Message.style.display = "block";

            this.dotFirst.style.display = "block";
            this.dotSecond.style.display = "block";
            // dotThird hidden
        } else {
            // < 2 items. Next goal: 5% off (2 items)
            this.offTenMessage.style.display = "block";
            this.dotFirst.style.display = "block";
        }

        if (this.cartCount === 0) {
            document.querySelector('.total-price').style.opacity = "0";
        } else {
            document.querySelector('.total-price').style.opacity = "1";
        }

        // Update remaining amount for freebie
        const remainingAmount = 2500 - this.cartPrice;
        this.querySelector('#remaining-amount').textContent = remainingAmount > 0 ? remainingAmount : 0;
    }

    async checkExcludedProductInCart() {
        // Hide the offer if it includes an excluded product from discount

        const cart = await fetch('/cart.js').then(res => res.json());
        const item = cart.items.find(i => this.excludedProducts.includes(i.product_id));

        if (item) {
            this.style.display = 'none'
            this.excludedProductInCart = true;
        } else if (this.cartCount || this.cartCount != 0) {
            this.style.display = 'block';
            this.excludedProductInCart = false;
        }

        this.checkingExcludedProduct = false;

    }


    async addToCart(variantId, quantity, properties = {}) {
        // if (this.excludedProductInCart || this.checkExcludedProductInCart) return;
        const body = {
            id: variantId,
            quantity: quantity,
            properties: properties
        };

        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(body)
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const cartResponse = await response.json();

            this.renderProducts();
            return cartResponse;
        } catch (error) {
            console.error('Error adding to cart:', error);
        }
    }


    async removeFromCart(data, render = true) {
        try {
            const cart = await fetch('/cart.js').then(res => res.json());
            const item = cart.items.find(i => i.variant_id === data.id);

            if (!item) {
                console.warn('Item not found in cart for removal:', data.id);
                return cart;
            }


            const response = await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: item.key,
                    quantity: 0
                })
            });

            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

            const cartRes = await response.json();

            if (render) {
                this.renderProducts();
            }
            return cartRes;
        } catch (error) {
            console.error('Error removing item from cart:', error);
            throw error;
        }
    }

    updateFreebie(e) {
        const selectedSize = e.target.value;
        let variantId = null;

        if (!this.freebieVariants) return;

        switch (selectedSize) {
            case 'S':
                variantId = this.freebieVariants.s;
                break;
            case 'M':
                variantId = this.freebieVariants.m;
                break;
            case 'L':
                variantId = this.freebieVariants.l;
                break;
            case 'XL':
                variantId = this.freebieVariants.xl;
                break;
            default:
                console.warn('Unknown size selected for freebie:', selectedSize);
                return;
        }

        if (this.isFreebieAdded && this.addedVariantId && this.addedVariantId !== variantId) {
            this.removeFromCart({ id: this.addedVariantId }, false).then(() => {
                this.addToCart(variantId, 1, { 'Freebie': ' 100% OFF' }).then(() => {
                    this.addedVariantId = variantId;
                    localStorage.setItem('addedVariantId', this.addedVariantId.toString());
                });
            });
        } else if (!this.isFreebieAdded) {
            // Add new freebie
            this.addToCart(variantId, 1, { 'Freebie': ' 100% OFF' }).then(() => {
                this.isFreebieAdded = true;
                this.addedVariantId = variantId;

                localStorage.setItem('isFreebieAdded', 'true');
                localStorage.setItem('addedVariantId', this.addedVariantId.toString());
            });
        }
    }

    async updateCart(variantId, quantity, properties = {}) {
        const body = {
            id: variantId,
            quantity: quantity,
            properties: properties
        };

        try {
            const response = await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(body)
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const cartResponse = await response.json();

            this.renderProducts();
            return cartResponse;
        } catch (error) {
            console.error('Error updating cart item:', error);
        }
    }

    renderProducts() {
        fetch(`${window.location.pathname}?sections=ajax-cart`)
            .then(response => response.text())
            .then(data => {

                // Clean and parse HTML
                let htmlString = data.replace(/\\n|\\t|\\/g, "").replace(/\n/g, "");
                let parser = new DOMParser();
                let html = parser.parseFromString(htmlString, "text/html");

                // Extract necessary elements
                let cartItems = html.querySelectorAll(".cart-item");
                let currentItems = document.querySelectorAll(".cart-item");
                let quantity = parseInt(html.querySelector('input[data-id="cart-count"]')?.value || 0);
                let emptyText = html.querySelector(".empty-cart");
                let totalPrice = parseInt(html.querySelector('checkout-offer-bar[data-cart-price]')?.dataset.cartPrice || 0);
                let totalPriceNormal = html.querySelector('checkout-offer-bar[data-cart-price-normal]')?.dataset.cartPriceNormal || '';

                // If cart items change or display flag is true, update the cart
                let cartBody = document.querySelector(".ajax-cart-body");
                cartBody.innerHTML = ""; // Clear cart

                if (emptyText) cartBody.appendChild(emptyText);

                cartItems.forEach(item => cartBody.appendChild(item));

                // Update checkout button visibility
                this.updateCheckoutVisibility(quantity);


                this.updateCartCount(quantity);

                throwUpdateCartEvent(quantity, totalPrice);
                document.querySelector('.cart-total').textContent = `${(totalPriceNormal)}`;
            })
            .catch(error => console.error("Error fetching cart data:", error));
    }

    updateCheckoutVisibility(quantity) {
        let checkoutButton = document.querySelector(".gokwik-checkout");
        if (checkoutButton) {
            checkoutButton.style.display = quantity === 0 ? "none" : "block";
        }
    }

    updateCartCount(count) {
        let countHolders = document.querySelectorAll(".cart-count");
        countHolders.forEach((el, ind) => {
            el.textContent = count;
        });
    }

    throwUpdateCartEvent(newCount, newPrice) {
        // This event is for checkout-offer-bar.js - checkout offer bar functionality
        const event = new CustomEvent("cartOfferUpdate", {
            detail: { newCount: newCount, newPrice: newPrice },
        });

        document.dispatchEvent(event);
    }


}

window.addEventListener('load', () => {
    customElements.define('checkout-offer-bar', CheckoutOfferBar);
});